/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItemWithSub
        to='/campaign'
        title='کمپین'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/general/gen022.svg'
      >
        <AsideMenuItem to='/campaign/new' title='کمپین جدید' hasBullet={true} />
        <AsideMenuItem to='/campaign/list' title='لیست کمپین ها' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItem
        to='/user/setting'
        icon='/media/icons/duotune/general/gen019.svg'
        title='تنظیمات'
        fontIcon='bi-layers'
      />
      <AsideMenuItemWithSub
        to='/payment'
        title='مالی'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/finance/fin008.svg'
      >
        <AsideMenuItem to='/payment/list' title='تاریخچه پرداخت' hasBullet={true} />
        <AsideMenuItem to='/payment/charge' title='شارژ کیف پول' hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub
        to='/tickets'
        title='پشتیبانی'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com012.svg'
      >
        <AsideMenuItem to='/tickets/list' title='لیست تیکت ها' hasBullet={true} />
        <AsideMenuItem to='/tickets/new' title='تیکت جدید' hasBullet={true} />
      </AsideMenuItemWithSub>
    </>
  )
}
